module.exports = __webpack_public_path__ + "static/img/ComputerTerminal_rightBG.f30c00f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/ComputerTerminal_rightBG.png
// module id = qC10
// module chunks = 1